
import { View } from 'backbone';

import BaseControlView from 'BaseControlView.js';
import template from 'report/control-chart.ejs';
import eventBus         from 'EventBus.js';
import constants        from "Constants.js";
import dragAndDropService from 'DragDropService.js';
import resizeController from 'ResizeController.js';
import * as d3 from 'd3.js';
import c3 from 'c3.js'; 
import util from '../../service/util/Util';

class PieChartView extends BaseControlView  {

        initialize( opts ) {
            super.initialize( opts );
            this.template = template;
            this.tagName = 'div';

            this.listenTo( eventBus, 'ButtonThemeChange', this.themeChangeRender);
            this.listenTo(this.model, 'change', this.render);

            return this;
        }
    
       
        get kind() {
            return 'ButtonControlView';
        }

        loadFromProperties() {
            const prop = this.model.get('Property');
            const sliceColors = _.find(prop, function(obj) { return obj._id === 'sliceColors' });
            const sliceValues = _.find(prop, function(obj) { return obj._id === 'sliceValues' });

            if(sliceColors) {
                let i = 0;
                _.forEach(sliceColors.Item, (item) => {
                    this.model.set('sliceColor' + i.toString(), item._value, {silent: true});
                    i++;
                });
            }
            if (sliceValues){
                 let i=0;
                 _.forEach(sliceValues.Item, (item) => {
                    this.model.set('pieText' + i.toString(), item._value, {silent: true});
                    i++;
                 });
            }
        }

        chartConfiguration(generalChartSelector) {
            let propVal = this.model.get('pieLabelsPositions');
            if (propVal === "none"){
                this.model.set({
                    'showPieLabel': false,
                    'showPieLegend': false
                });
            }else if(propVal === "inside" || propVal === "insideCallout"){
                this.model.set({
                    'showPieLabel': true,
                    'showPieLegend': false
                });
            }else if(propVal === "outside" || propVal === "outsideCallout"){
                this.model.set({
                    'showPieLabel': false,
                    'showPieLegend': true
                });
            }

            var c3config = {
                bindto: generalChartSelector,
                legend: {
                   show: this.model.get('showPieLegend')
                },
                size: {
                   height: parseInt(this.model.get('height')),
                   width: parseInt(this.model.get('width'))
                },
                data: {
                   // these are hard coded because its only for display purposes.
                   columns: [
                       ['Product A', 50],
                       ['Product B', 30],
                       ['Product C', 20]
                   ],
                   type : 'pie'
                },
                color: {
                   pattern: [
                       util._fixColorFormat(this.model.get('sliceColor0')),
                       util._fixColorFormat(this.model.get('sliceColor1')),
                       util._fixColorFormat(this.model.get('sliceColor2'))
                   ]
                },
                pie: {
                   label: {
                       format: function (value, ratio, id) {
                           return id;
                       },
                       show: this.model.get('showPieLabel')
                   }
                }
            }
            return c3config;
        }

        updateChartTextFont(generalChartSelector){ 
            $(generalChartSelector +' .c3-chart-arc text').css('font-family', this.model.get('fontFamily'))
                                                  .css('font-size',this.model.get('fontSize'));

            $(generalChartSelector +' .c3-chart-arc text').css('font-family', this.model.get('fontFamily'))
                                                  .css('font-size',this.model.get('fontSize'));
        }

        updateChartTextColor(generalChartSelector){
            $(generalChartSelector +' .c3-chart-arc text').css('fill',this.model.get('styleColorText'));
            $(generalChartSelector +' .c3-chart-arc text').css('fill',this.model.get('styleColorText'));
        }

        updateChartTextWeightAndStyle(generalChartSelector){
            $(generalChartSelector +' .c3-chart-arc text').css('font-weight',this.model.get('textWeight').split(' ')[0])
                                                  .css('font-style',this.model.get('textStyle').split(' ')[0]);
            $(generalChartSelector +' .c3-chart-arc text').css('font-weight',this.model.get('textWeight').split(' ')[0])
                                                  .css('font-style',this.model.get('textStyle').split(' ')[0]);
        }


        render() {
            const generalChartSelector=constants.ID_SEL + this.id +' div.c3-chart';
            if(!this.model.get('sliceColor0')){
                this.loadFromProperties();
            }
            super.render();

            d3.select(generalChartSelector).style("background-color", "transparent");

            var myModel = this.model;
            var chart = c3.generate(this.chartConfiguration(generalChartSelector));

            this.updateChartTextFont(generalChartSelector);
            this.updateChartTextColor(generalChartSelector);
            this.updateChartTextWeightAndStyle(generalChartSelector);

            this.validateToStayInBounds(this.model);
            this._hideControl(constants.ID_SEL + this.id,this.model.get('isHidden'));

            return this;
        }
}

export default PieChartView;
